import React from 'react';
import Styles from './DashboardScreen.module.scss'

interface Props {

}

const DashboardScreen: React.FC<Props> = () => {
    return (
        <div>
            Welcome Dashboard
        </div>
    );
};

export default DashboardScreen;
